import { __awaiter, __decorate, __extends, __generator } from "tslib";
import React from 'react';
import { FiasLocaleHelper } from '../locale';
import { FiasAddress } from '../models/FiasAddress';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { FiasComboBox } from './FiasComboBox';
var FiasCountrySelector = /** @class */ (function (_super) {
    __extends(FiasCountrySelector, _super);
    function FiasCountrySelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createItemsSource = function (prefix) { return __awaiter(_this, void 0, void 0, function () {
            var _a, api, limit;
            return __generator(this, function (_b) {
                _a = this.props, api = _a.api, limit = _a.limit;
                return [2 /*return*/, api.searchCountry({ prefix: prefix, limit: limit }).then(function (result) {
                        var success = result.success, data = result.data, error = result.error;
                        return success && data
                            ? Promise.resolve(data.map(function (country) {
                                return new FiasAddress({ country: country });
                            }))
                            : Promise.reject(error);
                    })];
            });
        }); };
        _this.renderItem = function (address) {
            var country = address.country;
            return (country && country.fullName) || '';
        };
        _this.renderValue = function (address) {
            var country = address.country;
            return (country && country.fullName) || '';
        };
        _this.renderNotFound = function () {
            return _this.locale.searchNotFound;
        };
        _this.valueToString = function (address) {
            var country = address.country;
            return (country && country.fullName) || '';
        };
        _this.handleValueChange = function (value) {
            var onValueChange = _this.props.onValueChange;
            if (onValueChange) {
                onValueChange(value.country);
            }
        };
        _this.onUnexpectedInput = function (query) {
            if (!query) {
                return new FiasAddress();
            }
            if (_this.props.allowArbitraryCountry) {
                return new FiasAddress({ country: { fullName: query, shortName: '', code: '' } });
            }
        };
        return _this;
    }
    FiasCountrySelector.prototype.render = function () {
        var _a = this.props, country = _a.country, limit = _a.limit;
        var address = new FiasAddress({ country: country });
        return (React.createElement(FiasComboBox, { getItems: this.createItemsSource, value: address, renderItem: this.renderItem, renderValue: this.renderValue, valueToString: this.valueToString, onValueChange: this.handleValueChange, onUnexpectedInput: this.onUnexpectedInput, renderNotFound: this.renderNotFound, placeholder: this.locale.countryPlaceholder, width: '100%', drawArrow: false, searchOnFocus: false, limit: limit }));
    };
    FiasCountrySelector.__KONTUR_REACT_UI__ = 'FiasCountrySelector';
    FiasCountrySelector.displayName = 'FiasCountrySelector';
    FiasCountrySelector = __decorate([
        locale('Fias', FiasLocaleHelper)
    ], FiasCountrySelector);
    return FiasCountrySelector;
}(React.Component));
export { FiasCountrySelector };
